// extracted by mini-css-extract-plugin
export default {"typography":"typography_typography__AOdPB","navbarTitle":"typography_navbarTitle__r7O9d"};